import { apiCall, ApiConfig } from '../../config/api'
import { TypeAsnIncome } from '../../interfaces/Asn/TypeAsnIncome'
import { getTypeAsnIncomeAction } from '../actions/typeAsnIncomeActions'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosError, AxiosResponse } from 'axios'
import { GET_TYPE_ASN_INCOME } from '../types/typeAsnIncomeActionsTypes'
import { DataGridElements } from '../../interfaces/index'

export function* getTypesAsnIncomeAsync() {
  try {
    const { status, data }: AxiosResponse<DataGridElements<TypeAsnIncome>> =
      yield call(apiCall, 'GET', `${ApiConfig.TypeAsnIncomeApi}?pageSize=50`)
    if (status === 200) {
      yield put(getTypeAsnIncomeAction(data.items))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getTypeAsnIncomeAction([], serverError.message))
  }
}

export function* watchGetTypesAsnIncomeAsync() {
  yield takeEvery(GET_TYPE_ASN_INCOME, getTypesAsnIncomeAsync)
}
